const checkisEnv = function () {
  return new Promise((resolve, reject) => {
    if (/MicroMessenger/.test(window.navigator.userAgent)) {
      window.wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          resolve('weapp_mini')
        } else {
          resolve('weapp')
        }
      })
    } else if (/AlipayClient/.test(window.navigator.userAgent)) {
      window.my.getEnv(res => {
        if (res.miniprogram) {
          resolve('alipay_mini')
        } else {
          resolve('alipay')
        }
      })
    } else {
      resolve('h5')
    }
  })
};
export{
  checkisEnv
}
